<template lang="">
  <div class="cardContentT">
    <div
      class="flex"
      style="margin-top:5px;padding-left: 10px;box-sizing:border-border-box;"
    >
      <div
        class="choseType"
        :class="active === index ? 'select' : ''"
        v-for="(item, index) in navList"
        :key="index"
        @click="typeSelect(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="chart" ref="qxLineChart" />
  </div>
</template>

<script>
import { loadChart } from "../chart/qxChartData";
import { getHasHistoryDevice, findWlwWeatherGetLSSJ } from "@/api/zhwl";
export default {
  data() {
    return {
      active: 0,
      navList: [
        {
          name: "今天",
          day: 1,
        },
        {
          name: "最近三天",
          day: 3,
        },
        {
          name: "最近一周",
          day: 7,
        },
      ],
      deviceCode: "",
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    typeSelect(item, index) {
      this.active = index;
      let startTime;
      if (item.day === 1) {
        // this.loadNowChart();
        startTime = this.$formatDate(
          new Date(new Date() - 1 * 24 * 3600 * 1000),
          "yyyy-MM-dd"
        );
      } else if (item.day === 3) {
        startTime = this.$formatDate(
          new Date(new Date() - 3 * 24 * 3600 * 1000),
          "yyyy-MM-dd"
        );
      } else if (item.day === 7) {
        startTime = this.$formatDate(
          new Date(new Date() - 7 * 24 * 3600 * 1000),
          "yyyy-MM-dd"
        );
      }
      this.loadDayChart(startTime);
    },
    loadData() {
      let startTime = this.$formatDate(
        new Date(new Date() - 1 * 24 * 3600 * 1000),
        "yyyy-MM-dd"
      );

      this.chart = this.$echarts.init(this.$refs.qxLineChart);
      getHasHistoryDevice().then((res) => {
        if (res && res.data && res.data.id) this.deviceCode = res.data.id;
        else this.deviceCode = "cca20468f32e4c63b3fc1678480b14fc";

        this.loadDayChart(startTime);
      });
      // this.loadNowChart();
      window.addEventListener("resize", () => {
        this.chart.resize();
      });
    },
    loadDayChart(startTime) {
      let endTime = this.$formatDate(new Date(), "yyyy-MM-dd");
      findWlwWeatherGetLSSJ({
        // deviceNo: this.graphic.code,
        wlwWeatherId: this.deviceCode,
        startTime,
        endTime,
        orderTime: "asc",
      }).then((res) => {
        loadChart(this.chart, res.data);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.flex
  display flex

.cardContentT
  height 100%
  .chart
    height 100%
.choseType
  margin 0 10px
  font-size 13px
  cursor pointer
  border-bottom 2px solid transparent
  color #00e2fb
.select
  color #ffd400
  border-bottom 2px solid
</style>
